module.exports = __webpack_public_path__ + "img/ics_o_arrow_down.36c357f0.svg";